<template>
  <div id="nav-wrapper" @mousemove="hoverSidebar = true" @mouseleave="hoverSidebar = false" :class="hideSidebar ? (hoverSidebar ? 'hide-sidebar hover-sidebar' : 'hide-sidebar') : ''
    ">
    <v-list :expand="true" color="primary" dense>
      <template v-for="menu in menus" v-if="checkRole(menu.roles, menu.slug, null)">
        <v-subheader dark v-if="menu.subHeader" :id="menu.slug">{{
          menu.subHeader
        }}</v-subheader>
        <div :class="menu.slug">
          <template v-if="menu.item.subItem && menu.item.subItem.length > 0 && checkRole(menu.item.roles, menu.slug, null)">
            <v-list-group :value="false" dark>
              <template v-slot:activator>
                <v-list-item-icon v-if="menu.item.icon" class="mr-1">
                  <v-icon v-text="menu.item.icon" size="20"></v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ menu.item.text }}</v-list-item-title>
              </template>
              <v-list-item-group>
                <template v-for="item in menu.item.subItem">
                  <v-list-item :href="item.link" v-if="checkRole(item.roles, menu.slug, item) && item.target" dark
                    :class="item.name === $route.name ? 'menu-item-active' : ''" target="_blank"
                    @click="resetLocalstorage()">
                    <v-list-item-icon v-if="item.icon" class="ml-2 mr-0">
                      <v-icon size="5">circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item>
                  <v-list-item :to="{name: item.name}" v-if="checkRole(item.roles, menu.slug, item) && !item.target" dark
                    active-class="menu-item-active" @click="resetLocalstorage()">
                    <v-list-item-icon v-if="item.icon" class="ml-2 mr-0">
                      <v-icon size="5">circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list-group>
          </template>
          <template v-else-if="checkRole(menu.item.roles, menu.slug, null)">
            <v-list-item-group>
              <template>
                <v-list-item v-if="menu.item.target" :href="menu.item.link" :target="menu.item.target ? '_blank' : ''"
                  dark link :class="menu.item.name === $route.name ? 'menu-item-active' : ''"
                  @click="resetLocalstorage()">
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20">{{ menu.item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ menu.item.text }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-else :to="{name: menu.item.name}" :target="menu.item.target ? '_blank' : ''" dark link
                  active-class="menu-item-active" @click="resetLocalstorage()">
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20">{{ menu.item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ menu.item.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </template>
        </div>
      </template>
    </v-list>

    <div class="copyright pr-5 pl-5 text-center" >
      <div class="d-flex align-items-center justify-content-center">
        <img :src="!dataMain ? logoCrsWhite : dataMain.logo" style="max-width: 100px" />  <span style="fon-size: 11px; position: relative; top: 2px">{{ version }}</span>
      </div>
      <p class="mb-0">{{ $t( !dataMain ? "_LEFT_MENU.COPY_RIGHT" : dataMain.copyRight) }}</p>
    </div>
  </div>
</template>
<script>
import eventBus from "@/_helpers/event-bus.js";
import { Role } from "@/plugins/roles";
import $ from "jquery";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import logoCrs from '@/assets/ezCrs-ngang.png';
import logoCrsWhite from '@/assets/ezCrs-ngang-trang.png';

export default {
  data() {
    return {
      logoCrs: logoCrs,
      logoCrsWhite: logoCrsWhite,
      selectedItem: 1,
      menus: [
        {
          subHeader: "",
          slug: "dashboard",
          roles: [],
          item: {
            text: this.$t("DASHBOARD"),
            icon: "dashboard",
            link: "h/dashboard",
            name: "widgets",
            roles: [],
          },
        },
        {
          subHeader: '',
          slug: "",
          roles: [],
          item: {
            text: this.$t("HOTEL_LIST"),
            icon: "dvr",
            link: "/chain-dashboard/chain-list",
            name: "chain-list",
            roles: [],
          },
        },
        {
          subHeader: this.$t("HOTEL_CHAIN"),
          slug: "hotel-chain",
          roles: ['CHAIN'],
          item: {
            text: this.$t("ROOM_SALE"),
            icon: "inventory",
            link: "/h/room-sale/room-sale/room-sale-otas",
            name: "roomSaleWithOTAs",
            roles: ["ROOM_SALE", "CHAIN"],
          },
        },
        {
          subHeader: "",
          slug: "hotel-chain",
          roles: ['CHAIN'],
          item: {
            text: this.$t("BOOKING_LIST"),
            icon: "event_note",
            link: "/h/chain/chain-booking-list",
            name: "chain-booking-list",
            roles: ['BOOKING_CHAIN'],
          },
        },
        {
          subHeader: "",
          slug: "hotel-chain",
          roles: ['CHAIN'],
          item: {
            text: this.$t("CHAIN_CONFIG"),
            icon: "settings",
            roles: ["CHAIN"],
            link: "https://google.com.vn",
            name: "google",
            subItem: [
              {
                text: this.$t("GENERAL_INFO"),
                icon: "mdi-clock",
                link: "/h/chain/chain-infomation",
                name: "chain-infomation",
                roles: ["CHAIN"],
              },
              {
                text: this.$t("TYPE_ROOM"),
                link: "/h/chain/room",
                name: "chain-room",
                icon: "mdi-clock",
                roles: ["CHAIN_ROOM_TYPE"],
              },
              // {
              //   text: this.$t("RATE_PMS"),
              //   link: "/h/h/chain/rate-pms",
              //   icon: "mdi-clock",
              //   roles: ["CHAIN_RATE_PLAN"],
              // },
              {
                text: this.$t("_SALE_PACKAGE.SALE_PACKAGE"),
                icon: "mdi-clock",
                link: "/h/chain/rate",
                name: "chainRate",
                roles: ["CHAIN_RATE_PLAN"],
              },
              {
                text: this.$t("SERVICES"),
                icon: "mdi-clock",
                link: "/h/chain/service",
                name: "chain-service",
                roles: ["CHAIN_SERVICE"],
              },
              {
                text: this.$t("CHAIN_AGENT_LIST"),
                link: "/h/chain/agent",
                name: "ChainAgent",
                icon: "mdi-clock",
                roles: ["CHAIN_TRAVEL_AGENT"],
              },
            ],
          },
        },
        {
          subHeader: "",
          slug: "hotel-chain",
          roles: ['CHAIN'],
          item: {
            text: this.$t("ACTIVITY_DAIRY"),
            icon: "watch_later",
            roles: ["HISTORY_LOG"],
            link: "/h/chain-log/log",
            name: "chainLogList",
            subItem: [
              {
                text: this.$t("ACTIVE_LOG"),
                icon: "mdi-clock",
                link: "/h/chain-log/log",
                name: "chainLogList",
                roles: ["HISTORY_LOG"],
              },
            ],
          },
        },
        {
          subHeader: this.$t("MANAGE"),
          slug: "manage",
          roles: ["MANAGE"],
          item: {
            text: this.$t("_ROLES.BOOKING_MANAGEMENT"),
            icon: "event_note",
            roles: ["BOOKING_MANAGEMENT"],
            link: "https://google.com.vn",
            name: "google",
            subItem: [
              {
                text: this.$t("BOOKING_LIST"),
                icon: "mdi-clock",
                link: "/h/booking/list-booking",
                name: "listBooking",
                roles: ["BOOKING_HOTEL"],
              },
              {
                text: this.$t("_ACTIVITY.HOTEL_UPDATE_PAYMENT_BOOKING"),
                link: "/h/transaction/list",
                name: "transactionList",
                icon: "mdi-clock",
                roles: ["HOTEL_BOOKING_CONFIRM"],
              },
              {
                text: this.$t("BOOKING_LIST_GROUP"),
                icon: "mdi-clock",
                link: "/h/group/info/list-booking",
                name: "listBookingGroup",
                roles: ["HOTEL_BOOKING_GROUP"],
              },
              {
                text: this.$t("BOOKING_UNMAP"),
                icon: "mdi-clock",
                link: "/h/booking/list-booking-unmap",
                name: "listBookingUnmap",
                roles: ["BOOKING_UNMAP_HOTEL"],
              }
            ],
          },
        },
        {
          subHeader: "",
          slug: "room-sale",
          roles: ["MANAGE"],
          item: {
            text: this.$t("ROOM_SALE"),
            icon: "inventory",
            link: "https://google.com.vn",
            name: "google",
            roles: ["ROOM_SALE"],
            subItem: [
              {
                text: this.$t("ROOM_SALE"),
                icon: "mdi-clock",
                link: "/h/room-sale/room-sale",
                name: "roomSaleWithOTAs",
                roles: ["ROOM_SALE_MANAGEMENT"],
              },
              {
                text: this.$t("DERIVED"),
                icon: "mdi-clock",
                link: "/h/master-rate/overview",
                name: "master-rate-overview",
                roles: ["MASTER_RATE"],
              },
              {
                text: this.$t("_SALE_PACKAGE.SALE_PACKAGE"),
                link: "/h/room-sale/rate",
                name: "rate",
                icon: "mdi-clock",
                roles: ["SALE_PACKAGE_MANAGEMENT"],
              },
              {
                text: this.$t("SERVICES") + " (ezBe)",
                icon: "room_service",
                roles: ["HOTEL_SERVICE"],
                link: "/h/service/list",
                name: "serviceList",
              },
              {
                text: this.$t("PROMOTION") + " (ezBe)",
                icon: "spa",
                roles: ["HOTEL_PROMOTION"],
                link: "/h/promotion/list",
                name: "promotionList",
              }
            ],
          },
        },
        {
          subHeader: "",
          slug: "crs-manage",
          roles: ["MANAGE"],
          item: {
            text: this.$t("RMS_MANAGEMENT"),
            icon: "bar_chart",
            link: "https://google.com.vn",
            name: "google",
            roles: ['RMS_MANAGEMENT', 'RMS'],
            subItem: [
              {
                text: this.$t("DYNAMIC_SALE"),
                link: "/h/rms-management/dynamic",
                name: "dynammic-component",
                icon: "mdi-clock",
                roles: ['DYNAMIC_ROOM_SALE']
              },
              {
                text: this.$t("OVERVIEW"),
                link: "/h/rms-management/overview",
                name: "dynammic-overview",
                icon: "mdi-clock",
                roles: ['DYNAMIC_ROOM_SALE']
              },
            ]
          }
        },
        {
          subHeader: "",
          slug: "manage_sync_ota",
          roles: ["MANAGE"],
          item: {
            text: this.$t("COMBO") + " (ezBe)",
            icon: "hive",
            link: "https://google.com.vn",
            name: "dashboard",
            roles: ["PACKAGE_MANAGEMENT"],
            subItem: [
              {
                text: this.$t("PACKAGE_DEAL"),
                icon: "mdi-clock",
                link: "/h/combo/package",
                name: "package",
                roles: ["PACKAGE_DEAL"],
              },
              {
                text: this.$t("PACKAGE_ITEM"),
                icon: "mdi-clock",
                link: "/h/combo/services",
                name: "service-combo",
                roles: ["PACKAGE_ITEM"],
              },
            ],
          },
        },
        {
          subHeader: "",
          slug: "manage_sync_ota",
          roles: ["MANAGE"],
          item: {
            text: this.$t("MANAGE_SYNC_OTA"),
            icon: "cloud",
            link: "https://google.com.vn",
            name: "dashboard",
            roles: ["SYNC_MANAGEMENT"],
            subItem: [
              {
                text: "ezPriceLabs",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezPriceLabs",
                name: "ezPriceLabs",
                roles: ['RPD'],
              },
              {
                text: "ezBe",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezbe-ota",
                name: "ezbe",
                roles: ["BER"],
              },
              {
                text: "ezApiApp",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezApiApp",
                name: "ezApiApp",
                roles: ["AIA"],
              },
              {
                text: "ezApiKiosk",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezApiKiosk",
                name: "ezApiKiosk",
                roles: ["AIK"],
              },
              {
                text: "ezApiPms",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezApiPms",
                name: "ezApiPms",
                roles: ["AIP"],
              },
              {
                text: 'ezCms Vela',
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCmsVela",
                name: "ezCmsVela",
                roles: ["CMV"],
              },
              {
                text: this.$t("MANAGE_ALIAS_OTA") + ' ⁺',
                icon: "mdi-clock",
                link: "/sync-manage/ezCmsVelaPlus",
                name: "ezCmsVelaPlus",
                roles: ["CMP"],
              },
              {
                text: 'ezCms 1h',
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCms1H",
                name: "ezCms1H",
                roles: ["CMH"],
              },
              {
                text: 'ezCms Leo',
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCmsLeo",
                name: "ezCmsLeo",
                roles: ["CML"],
              },
              {
                text: "ezCms 1i",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCms1i",
                name: "ezCms1i",
                roles: ["CMI"],
              },
              {
                text: "ezCms 1s",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCms1S",
                name: "ezCms1S",
                roles: ["CME"],
              },
              {
                text: "ezCms 1x",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCms1X",
                name: "ezCms1X",
                roles: ["CMX"],
              },
              {
                text: "ezCms 1t",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCms1T",
                name: "ezCms1T",
                roles: ["CMD"],
              },
              {
                text: "ezCms SiteMinder",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCmsSiteminder",
                name: "ezCmsSiteminder",
                roles: ["CMM"],
              },
              {
                text: "ezCms Traveloka",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCmsTraveloka",
                name: "ezCmsTraveloka",
                roles: ["CMK"],
              },
              {
                text: "ezCms StaahMax",
                icon: "mdi-clock",
                link: "/h/sync-manage/ezCmsStaahMax",
                name: "ezCmsStaahMax",
                roles: ["CSM"],
              },
            ],
          },
        },
        {
          subHeader: this.$t("SETTING"),
          slug: "setting",
          roles: ['SETTING'],
          item: {
            text: this.$t("ACCOUNT_INFO"),
            icon: "group",
            link: "https://google.com.vn",
            name: "dashboard",
            roles: ["ACCOUNT_INFOMATION"],
            subItem: [
              {
                text: this.$t("ACCOUNT_SETTING"),
                icon: "mdi-clock",
                link: "/h/account/my-account",
                name: "accountSetting",
                roles: ["PERSONAL_ACCOUNT"],
              },
            ],
          },
        },
        {
          subHeader: "",
          slug: "hotel-infomation",
          roles: ['SETTING'],
          item: {
            text: this.$t("HOTEL_INFOMATION"),
            icon: "location_city",
            link: "https://google.com.vn",
            name: "dashboard",
            roles: ['HOTEL_INFORMATION'],
            subItem: [
              {
                text: this.$t("GENERAL_INFO"),
                icon: "mdi-clock",
                link: "/h/hotel-setting/info/register",
                name: "registerInfomation",
                roles: ["GENERAL_INFORMATION"],
              },
              {
                text: this.$t("HOTEL_CONFIG"),
                icon: "mdi-clock",
                link: "/h/hotel-setting/config",
                name: "generalSetting",
                roles: ["HOTEL_CONFIGURATION"],
              },
              {
                text: this.$t("GALLERY_MANAGER"),
                icon: "mdi-clock",
                link: "/h/hotel-setting/gallery",
                name: "hotelSettingGallery",
                roles: ["IMAGE_LIBRARY"],
              },
              {
                text: this.$t("TYPE_ROOM"),
                icon: "mdi-clock",
                link: "/h/hotel-setting/room",
                name: "roomGroup",
                roles: ["ROOM_TYPE"],
              },
              {
                text: this.$t("CHAIN_AGENT_LIST"),
                link: "/h/hotel-setting/agent",
                name: "agent-hotel",
                icon: "mdi-clock",
                roles: ["HOTEL_TRAVEL_AGENT"],
              },
            ],
          },
        },
        {
          subHeader: "",
          slug: "hotel-log",
          roles: ['SETTING'],
          item: {
            text: this.$t("ACTIVITY_DAIRY"),
            icon: "watch_later",
            roles: ["HISTORY_LOG"],
            link: "/h/hotel-log/log",
            name: "hotelLogList",
            subItem: [
              {
                text: this.$t("ACTIVE_LOG"),
                icon: "mdi-clock",
                link: "/h/hotel-log/log",
                name: "hotelLogList",
                roles: ["HISTORY_LOG"],
              },
              {
                text: this.$t("OTA_LOG"),
                icon: "mdi-clock",
                link: "/h/hotel-log/logOta",
                name: "OTALog",
                roles: ["HISTORY_LOG"],
              },
              // {
              // 	text: this.$t("INVENTORY_LOG"),
              // 	icon: "mdi-clock",
              // 	link: "/h/hotel-log/logInventory",
              // 	roles: ['HISTORY_LOG']
              // },
              // {
              // 	text: this.$t("ERROR_LOG"),
              // 	icon: "mdi-clock",
              // 	link: "/h/hotel-log/logError",
              // 	roles: ['HISTORY_LOG']
              // }
            ],
          },
        },
      ],
      hoverSidebar: false,
      hideSidebar: JSON.parse(localStorage.getItem("hideSidebar")),
      right: true,
      userRole: null,
      isConnectBe: null,
    };
  },
  mounted() {
    // $(".v-list-group__items").each(function () {
    //   if ($(this).find("a").length == 0) {
    //     $(this).parent().addClass("d-none");
    //   }
    // });
    // $(".v-list-item-group").each(function () {
    //   if ($(this).find("a").length == 0) {
    //     $(this).addClass("d-none");
    //   }
    // });

    if (
      $(".setting").find(".d-none").length > 0 &&
      $(".hotel-infomation").find(".d-none").length > 0 &&
      $(".hotel-log").find(".d-none").length > 0
    ) {
      $("#setting").addClass("d-none");
    }

    if (
      $(".manage").find(".d-none").length > 0 &&
      $(".manage_sync_ota").find(".d-none").length > 0 &&
      $(".room-sale").find(".d-none").length > 0
    ) {
      $("#manage").addClass("d-none");
    }

    // if ( !JSON.parse(localStorage.getItem("showmenuchain")) ) {
    // $('.hotel-chain').addClass("d-none");
    // }
  },
  methods: {
    handleScroll() {
      document.getElementById("left-menu").style.height = `${document.body.offsetHeight - 60
        }px`;
    },
    toggleItem(groupId, index) {
      let isActive = this.items.find((x) => x.id == groupId).data[index].active;
      this.items.find((x) => x.id == groupId).data[index].active = !isActive;
    },
    resetLocalstorage() {
      // Nếu không ở màn hình bán phòng thì xoá các lựa chọn kênh bán, meta data trong local storage đi.
      if (this.$route.name != "roomSale") {
        // localStorage.removeItem("currentFilterRoomSale");
        localStorage.removeItem("currentOTARoomSale");
      }
    },
    reloadSidebar() {
      this.hideSidebar = JSON.parse(localStorage.getItem("hideSidebar"));
    },
    checkRole(roles, slug, item) {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      const userRole = currentUser.user.roles.map((role) => role.fnCode);
      const queryString = window.location.href;
      const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
      if (slug === 'hotel-chain' && !ob.hotel.chainId) {
       return false;
      }
      return roles.every(element => userRole.includes(element));
    },
    sortMenu() {
      this.menus.forEach((menu) => {
        if (
          menu.item &&
          menu.item.text == this.$t("MANAGE_SYNC_OTA") && 
          menu.item.subItem &&
          menu.item.subItem.length > 0
        ) {
          menu.item.subItem.sort((a, b) => a.text.localeCompare(b.text));
        }
      });
    }
  },
  created() {
    eventBus.$on("EVENT_RELOAD_SIDEBAR", () => this.reloadSidebar());
    // Render menu by role
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    this.userRole = currentUser.user.roles.map((role) => role.fnCode);
    let body = {
      keyword: "",
      status: 1,
    };
    syncota.getAllOTA(body).then((res) => {
      if (res.responseCode === 0) {
        const connectBe = res.data.find((e) => e.otaCode === "EZ_BE");
        if (connectBe && connectBe.status === true) {
          const queryString = window.location.href;
          const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
          let hotelId = this.$route.params.hotelIdParam || '';
          let link = localStorage.getItem(`${hotelId}-beLink`);
          if (link && link.endsWith('/')) {
            link = link.slice(0, -1);
          }
          const baseUrl = link && link !== 'null' && link !== 'undefined' ? link : process.env.VUE_APP_BE_BASE_URL;
          this.menus.push({
            subHeader: this.$t("BOOKING_ENGINE"),
            slug: "booking-engine",
            roles: ['BOOKING_ENGINE'],
            item: {
              text: this.$t("_PAYGATE.CONFIGURATION"),
              icon: "settings",
              link: "https://google.com.vn",
              name: "dashboard",
              roles: ['BOOKING_ENGINE_CONFIG'],
              subItem: [
                {
                  text: this.$t("_ACCOUNT_SETTING.EMAIL"),
                  icon: "mdi-clock",
                  link: "/h/hotel-be/email",
                  name: "email",
                  roles: ["HOTEL_EMAIL"],
                },
                {
                  text: this.$t("HEADER_FOOTER_CONFIG"),
                  icon: "Code",
                  link: "/h/hotel-be/theme",
                  name: "theme",
                  roles: ["HEADER_FOOTER"],
                },
                {
                  text: this.$t("INSTRUCTION_DOCUMENT_CONNECT_BE"),
                  icon: "mdi-clock",
                  link: "/h/hotel-be/support",
                  name: "support",
                  roles: [],
                  target: false,
                },
              ],
            },
          });
          this.menus.push({
            subHeader: "",
            slug: "preview-be",
            roles: [],
            item: {
              text: this.$t("PREVIEW_ON_BE"),
              icon: "storefront",
              roles: [],
              link: `${baseUrl}/hotel/BeHome?hotel_code=${ob.hotel.hotelCode}&currency=VND`,
              name: "preview",
              target: true,
            },
          });
        }
      } else {
        this.isConnectBe = null;
      }
    });
    this.sortMenu();
  },
};
</script>
